import { axiosPrivate } from "../../../api/axios";
import { LogLevel, } from "./Logging-types";
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga4";
import { datadogLogs } from "@datadog/browser-logs";
/**
 * Log events to Klaviyo
 * @param eventName
 * @param eventInfo
 */
export const createKlaviyoEvent = (companyUsesKlaviyo) => (eventName, eventInfo = {}) => {
    if (companyUsesKlaviyo) {
        axiosPrivate.post(`/OrderFlow/ExportKlaviyoEvent?eventName=${eventName}`, eventInfo).catch(() => { });
    }
};
/**
 * Log events to React Pixel
 * @param title
 * @param data
 */
export const logReactPixel = (pixelKey) => (title, data = {}) => {
    if (pixelKey) {
        ReactPixel.trackCustom(title, data);
    }
};
export const logReactPixelPageView = (pixelKey) => () => {
    if (pixelKey) {
        ReactPixel.trackSingle(pixelKey.KeyValue, "PageView");
    }
};
export const gaEvent = (gaKey) => (title, data = {}) => {
    if (gaKey) {
        ReactGA.event(title, data);
    }
};
export const gaPageView = (gaKey) => (page_title, page_location) => {
    if (gaKey) {
        ReactGA.event("page_view", {
            page_title: page_title,
            page_location: page_location,
        });
    }
};
/**
 * Log events to Datadog
 * @param msg
 * @param payload
 */
export const datadogLog = (env, build, application) => (msg, type, messageContext, error) => {
    const contextWithEnvData = Object.assign(Object.assign({}, messageContext), { environment: env, build_number: build, application: application });
    switch (type) {
        case LogLevel.INFO:
            datadogLogs.logger.info(msg, contextWithEnvData, error);
            break;
        case LogLevel.DEBUG:
            datadogLogs.logger.debug(msg, contextWithEnvData, error);
            break;
        case LogLevel.WARN:
            datadogLogs.logger.warn(msg, contextWithEnvData, error);
            break;
        case LogLevel.ERROR:
            datadogLogs.logger.error(msg, contextWithEnvData, error);
            break;
    }
};
/**
 * This function configures the DataDog SDK with the provided parameters,
 * setting up the necessary environment, versioning, and service identification
 * for effective logging.
 *
 * @param {string} token - The client token provided by DataDog for authentication.
 * @param {string} environment - The current application environment (e.g., production, development).
 * @param {string} build - The build version of the application.
 * @param {string} applicationName - The name of the application or service.
 */
export const datadogInit = (token, environment, build, applicationName) => {
    datadogLogs.init({
        clientToken: token,
        env: environment,
        version: build,
        service: applicationName,
    });
};
